
import {Component, Prop, Vue} from 'vue-property-decorator'
import HeaderBar from '@/components/common/Header.vue'

@Component({
  components: {
    HeaderBar
  }
})
export default class DefaultLayout extends Vue {
  @Prop() private msg!: string
}
